// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "integration_onedrive-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-C1azEbgd_mjs":"1ce9a449167852af48f0","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-CDU2njOJ_mjs":"4111b2c30e3b208b6112"}[chunkId] + "";
};